import type {LoginFormData, RegisterFormData} from './types';

export enum AuthPref {
	FORCE_EMAIL_LOGIN = 'user.force_email_login',
	REGISTER_AUTO_LOGIN = 'user.self_registration_auto_login',
	PASSWORD_RESET_DISABLED = 'user.disableForgotPassword',
	SELF_REGISTRATION = 'user.self_registration',
}

export const POST_LOGIN_HASH_NAME = 'postLoginHash';

export const UNCHANGED_PASSWORD = '********';

export const LOGIN_DEFAULTS: LoginFormData = {
	login: '',
	password: '',
};

export const REGISTER_DEFAULTS: RegisterFormData = {
	autogeneratePassword: false,
	email: '',
	login: '',
	name1: '',
	name3: '',
	password1: '',
	password2: '',
};
